export enum OrderRoutesAssociationEnum {
    Account = 1,
    AccountGroup = 2,
    TradingPlan = 3
}
